/* eslint-disable no-undef */
import React, { useCallback, useEffect, useState  } from "react";
import { useNavigate, Link, useLocation, useParams } from "react-router-dom";
import MobileFooter from "../../componant/mobileFooter";
import { headerText } from "../../App";
import { useAtom } from "jotai";
import moment from "moment";
import { 
  postReviewDetail, 
  postUpdReview,
  postInsReviewComment, 
  postUpdReviewComment,
  postDelReview,
} from "../../api/customerCenter";
import { postGetCommFile } from "../../api/mypage";
import FilePreviewModal from "../../componant/modal/FilePreviewModal";
import ModalConfirm from "../../componant/modal/modalConfirm";
import AutoResizeTextarea from "../../componant/AutoResizeTextarea";
import { toast } from "wc-toast";
import useWindowSize from "../../utils/hooks/useWindowSize";
import getUserInfo from "../../utils/hooks/getUserInfo";

import useTable from "../../utils/hooks/useTable";
import { Pagination } from "react-bootstrap";

export default function ReviewDetail({ }) {
  const [headerTextAtom, setHeaderTextAtom] = useAtom(headerText);
  const [activeTab, setActiveTab] = useState(1);

  const [detailData, setDetailData] = useState({});
  const [userInfo, setUserInfo] = useState();
  const location = useLocation();

  useEffect(() => {
    // if (location?.state) {
    //   setActiveTab(location?.state);
    // } else {
    //   setActiveTab(1);
    // }
    setHeaderTextAtom("이용후기\u00A0\u00A0상세보기");
  }, []);

  const { width } = useWindowSize();
  // const {
  //   dense,
  //   order,
  //   page,
  //   totalPage,
  //   orderBy,
  //   rowsPerPage,
  //   selected,
  //   visiblePages,
  //   onSort,
  //   onSelectRow,
  //   onSelectAllRow,
  //   onChangePage,
  //   onChangeTotalPage,
  //   onChangeDense,
  //   onChangeRowsPerPage,
  //   // setTotalPage,
  // } = useTable({
  //   defaultDense: "30px",
  //   defaultOrder: "name",
  //   defaultOrderDirection: "asc",
  //   defaultCurrentPage: 1,
  //   defaultRowsPerPage: 10,
  //   defaultSelected: {},
  //   mobileBreakpoint: 768, // px 붙이지 말 것
  //   maxPagesMobile: 10,
  //   maxPagesDesktop: 10,
  //   paginationType: "dynamic",
  //   Pagination,
  // });

  const { seq } = useParams();

  const navigate = useNavigate();
  const access_token = localStorage.getItem("access_token");
  const [previews, setPreviews] = useState([]); // url 모두 들어간 값
  const [showModal, setShowModal] = useState(false);
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null); // 선택한 file url만 들어가서 미리보기 띄워줌
  const [contentType, setContentType] = useState("");
  const isNocomment = detailData.nocomment_yn === "Y";
  const isMyPost = detailData?.user_seq === userInfo?.user_seq;  // 나의 후기작성인지

  // 댓글, 답글
  const [commentText, setCommentText] = useState("");
  const [replyText, setReplyText] = useState("");
  const [replyTarget, setReplyTarget] = useState(null);

  // 현재 수정 중인 댓글 ID, 댓글내용
  const [editTarget, setEditTarget] = useState(null);       
  const [editText, setEditText] = useState("");


  // 파일 가져오는 함수
  const getFiles = useCallback(async (fileSeq) => {
    const data = { file_seq: fileSeq };
    try {
      const response = await postGetCommFile(data);
      // console.log(response);
      // console.log(response.data);
      // const contentDisposition = response.headers["content-disposition"];
      // const filename = contentDisposition.match(/filename\*=UTF-8''(.+)/)[1];
      // const decodedFilename = decodeURIComponent(filename);

      const contentType = response.headers["content-type"];

      const blob = new Blob([response.data], { type: contentType });
      const previewUrl = URL.createObjectURL(blob);

      setContentType(contentType);
      return previewUrl;

      // *추가start - 이용후기에선 다운로드 안함
      // const reader = new FileReader();

      // if ((typeof TOPTOP_APP) === 'object' && (typeof TOPTOP_APP.getBase64FromBlobData) === 'function') {
      //   console.log('Android');
      //   reader.readAsDataURL(blob);
      //   reader.onloadend = () => {
      //     const base64data = reader.result;
      //     console.log('contentType-------222222>>',contentType);
      //     TOPTOP_APP.getBase64FromBlobData(decodedFilename, contentType, base64data);
      //   };
      // } else if (isIOS()){
      //   console.log('IOS');
      //   reader.readAsDataURL(blob);
      //   reader.onloadend = () => {
      //     const base64data = reader.result;
      //     var message = {filename : decodedFilename, type : contentType, data : base64data}
      //     webkit.messageHandlers.getBase64FromBlobData.postMessage(message);
      //   };
      // } else {
      //   console.log('PC');
      //   const a = document.createElement("a");
      //   a.href = previewUrl;
      //   a.download = decodedFilename;
      //   document.body.appendChild(a);
      //   a.click();
      //   document.body.removeChild(a);
      //   URL.revokeObjectURL(previewUrl);
      // }
      // *end

      // 파일 정보 상태 업데이트 (선택적)
      // setFiles((prevFiles) => [
      //   ...prevFiles,
      //   { fileName: decodedFilename, previewUrl },
      // ]);
    } catch (error) {
      // alert("파일 다운로드에 실패했습니다.");
      console.error(error);
    }
  }, []);

  // ------------------------------------------------------------------------------------------------

  const fetchData = useCallback(async () => {
    try {
      const data = { review_seq: seq };
      const response = await postReviewDetail(data);

      if (response.code === 1000) {
        setDetailData(response.result);
        const files = response?.result?.files || [];

        const previewUrls = await Promise.all(
          files.map((item) => getFiles(item.file_seq))
        );
        setPreviews(previewUrls);
      }
    } catch (error) {
      // console.error(error);
      alert("상세 정보를 가져오지 못했습니다.");
    }
  }, []);

  const callInfo = async () => {
    const userInfo = await getUserInfo();
    setUserInfo(userInfo);
  };

    useEffect(() => {
    if (access_token) {
      fetchData();
      callInfo();
    }
  }, [access_token]);
  
  const handlePreview = (previewUrl) => {
    setShowModal(true);
    setPreviewUrl(previewUrl);
  };

  const onSubmitComment = async (seq, text) => {
    if (!commentText || commentText === "") {
      return toast.error("댓글을 입력해 주세요.");
    }
    const data = {
      review_seq : seq,
      contents : text,
    }
    await postInsComment(data);
  };

  const onSubmitReply = async (c_seq, text) => {
    if (!replyText || replyText === "") {
      return toast.error("답글을 입력해 주세요.");
    }
    const data = {
      review_c_seq : c_seq,
      contents : text,
    }
    await postInsComment(data);    
  };

  const postInsComment = async (data) => {
    try {
      const response = await postInsReviewComment(data);
      // console.log("aaaaaaa", response);
      if (response.code === 1000) {
        fetchData();
      }
    } catch (error) {
      // console.error(error);
      toast.error("등록이 되지 않았습니다. 다시 시도해주세요.");
    }
  };
 
  const onUpdateComment = async (c_seq, text) => {
    try {
      const data = {
        review_c_seq: c_seq,
        contents: text,
      };
      
      const response = await postUpdReviewComment(data); // 수정용 API 호출
      if (response.code === 1000) {
        fetchData(); // 새로고침
      }
    } catch (err) {
      toast.error("수정되지 않았습니다. 다시 시도해주세요.");
    }
  };

  const onDeleteComment = async (flag, c_seq) => {
    try {
      const seq = flag === 'review' ? 'review_seq' : 'review_c_seq' ;
      const data = {
        [seq]: c_seq,
      };
      
      const response = await postDelReview(data); // 수정용 API 호출
      if (response.code === 1000) {
        if ( seq === 'review_seq' ) {
          navigate("/announcement", { state: 3 });
        }
        fetchData();     
      }
    } catch (err) {
      toast.error("삭제되지 않았습니다. 다시 시도해주세요.");
    }
  };

  return (
    <>
      {/* customer_tab 상단 네비게이션바와 위 아래 간격 주는 div */}
      <div className="customer_tab bg-white">
        {/* max-width: 1080px; width: calc(100% - 56px) */}
        <div className="container">
          <div className="main-heading d-md-block d-none">
            <h3 className="text-left">이용후기 상세보기</h3>
          </div>
          <hr className="information-hr pc_view" />
          <div
            className="list-item"            
            // style={{
            //   display: "flex",
            //   flexDirection: "column",
            //   justifyContent: "flex-start",
            //   flexWrap: "wrap",
            // }}
          >
            <span className="text" style={{fontSize: '20px'}}>{detailData?.title}</span>
            <span className="date">
              {detailData.user_nm} / {detailData.reg_dt} / 조회{" "}
              {detailData.hit_cnt} / 댓글 {detailData.cCnt}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "5px",
              marginTop: previews?.length > 0 ? "15px" : "0px",
              paddingLeft: "1rem"
            }}
          >
            {previews?.map((preview, index) => (
              <div
                key={index}
                style={{
                  position: "relative",
                  width: "70px",
                  height: "70px",                  
                }}
              >
                <img
                  src={preview}
                  alt={`preview-${index}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "5px",
                  }}
                  onClick={() => handlePreview(preview)}
                />
              </div>
            ))}
          </div>
          <div
            className="list-item"
            style={{
              padding: "2rem 1rem",
              overflowWrap: "break-word",
              whiteSpace: "pre-wrap",
            }}
          >
            {detailData?.contents}
            {/* {postData?.contents?.split("\n").map((line) => (
              <p>{line}</p>
            ))} */}
          </div>

          {/* 후기 수정, 삭제 */}
          {isMyPost && (
            <div className="d-flex gap-2 justify-content-end mt-2 me-2">
              <button style={{ border:"0px", borderRadius:'4px', padding:'5px 8px'}} onClick={() => navigate(`/review/${detailData.review_seq}/edit`)}>수정</button>
              <button style={{ border:"0px", borderRadius:'4px', padding:'5px 8px'}} onClick={() => setShowModalConfirm(true)}>삭제</button>
            </div>
          )}

          {/* 댓글 */}
          <div className="question_answer">
            {detailData.cCnt > 0 && (
              <div style={{fontSize:'18px', fontWeight:'bold', borderBottom:'1px solid #ccc'}}>댓글({detailData.cCnt})</div>
            )}
            {detailData?.reviewClist
              ?.filter((comment) => comment.depth === 1)
              .map((parent) => (
                <div key={parent.review_c_seq} className="comment-item">
                  {/* 댓글 */}
                  {parent.del_yn === 'Y' ? (
                    <>
                    <div className="title" style={{color:"#ccc"}}>삭제된 댓글 입니다.</div>
                    <div className="sub2">{parent.reg_dt}</div>
                    </>
                  ) : (
                    <>
                    <div className="title">{parent.user_nm}</div>
                    {/* 댓글수정창 */}
                    {/* {editTarget === parent.review_c_seq ? (
                      <div style={{ display: "flex", gap: "1px", marginTop: "8px", width:'100%' }}>
                        <AutoResizeTextarea
                          value={editText}
                          onChange={(e) => setEditText(e.target.value)}
                          />
                          <button
                            onClick={() => {
                              onUpdateComment(parent.review_c_seq, editText);
                              setEditTarget(null);
                              setEditText("");
                            }}
                            style={{
                              alignSelf: "stretch",
                              padding: "5px 10px",
                              fontSize: "14px",
                              backgroundColor: "#81b8f8",
                              color: "#fff",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                              width:'35%',
                            }}
                          >
                            수정 완료
                          </button>
                      </div>
                    ) : ( */}
                    <div className="sub1">{parent.contents}</div>
                    {/* )} */}
                    <div className="sub2">
                      {moment(parent.reg_dt)?.format('YYYY-MM-DD / HH:mm')}
                      {/* {parent.reg_dt?.slice(0,10)} / {parent.reg_dt?.slice(11,16)} */}
                      {/*
                      <span
                        style={{ color: "blue", cursor: "pointer", fontSize:'12px' }}
                        onClick={() => {
                          setReplyTarget((prev) =>
                            prev === parent.review_c_seq ? null : parent.review_c_seq
                          );
                          setReplyText(""); // 초기화
                        }}
                      >
                        답글쓰기
                      </span> */}
                      {/* {parent?.user_seq === userInfo?.user_seq && (
                        <>
                        <span
                          style={{ cursor: "pointer", fontSize: '12px'}}
                          onClick={() => {
                            setEditTarget(parent.review_c_seq);
                            setEditText(parent.contents); // 기존 댓글 내용 입력창에 세팅
                          }}
                        > 
                          {" "}/{" "}수정
                        </span>
                        <span
                          style={{ cursor: "pointer", fontSize: '12px' }}
                          onClick={() => {
                            onDeleteComment('comment', parent.review_c_seq);
                          }}
                        >
                          {" "}/{" "}삭제
                        </span>
                        </>
                      )} */}
                    </div>
                    </>
                  )}

                  {/* 답글 입력창 */}
                  {replyTarget === parent.review_c_seq && (
                    <div style={{ display: "flex", gap: "1px", marginTop: "8px", width:'100%' }}>
                      <AutoResizeTextarea
                        value={replyText}
                        onChange={(e) => setReplyText(e.target.value)}
                        placeholder= {isNocomment ? "답글을 제한하였습니다" : "답글을 입력하세요"}
                        readOnly={isNocomment}
                      />                      
                      <button
                        onClick={() => {
                          onSubmitReply(replyTarget, replyText);
                          setReplyTarget(null);
                          setReplyText("");
                        }}
                        style={{
                          alignSelf: "stretch",
                          padding: "5px 10px",
                          fontSize: "14px",
                          backgroundColor: isNocomment ? "#ccc" : "#81b8f8",
                          color: "#fff",
                          border: "none",
                          borderRadius: "4px",
                          cursor: isNocomment ? "not-allowed" : "pointer",
                          width:'35%',
                        }}
                        disabled={isNocomment}
                      >
                        등록하기
                      </button>
                    </div>
                  )}

                  {/* 답글들 */}
                  {detailData.reviewClist
                    .filter(
                      (child) =>
                        child.depth === 2 &&
                        child.parent_seq === parent.review_c_seq
                    ).map((reply) => (
                      <div
                        key={reply.review_c_seq}
                        style={{
                          marginLeft: "20px",
                          padding: "8px 0",
                          // borderLeft: "2px solid #ccc",
                        }}
                      >
                        <div className="title">{reply.user_nm}</div>

                        {editTarget === reply.review_c_seq ? (
                          <div style={{ display: "flex", gap: "1px", marginTop: "8px", width:'100%' }}>
                            <AutoResizeTextarea
                              value={editText}
                              onChange={(e) => setEditText(e.target.value)}
                              />
                              <button
                                onClick={() => {
                                  onUpdateComment(reply.review_c_seq, editText);
                                  setEditTarget(null);
                                  setEditText("");
                                }}
                                style={{
                                  alignSelf: "stretch",
                                  padding: "5px 10px",
                                  fontSize: "14px",
                                  backgroundColor: "#81b8f8",
                                  color: "#fff",
                                  border: "none",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  width:'35%',
                                }}
                              >
                                수정 완료
                              </button>
                          </div>
                        ) : (
                        <div className="sub1">{reply.contents}</div>
                        )}
                        {/* <div className="sub1">{reply.contents}</div> */}
                        <div className="sub2">
                          {reply.reg_dt}
                          {reply?.user_seq === userInfo?.user_seq && (
                            <>
                            <span
                              style={{ cursor: "pointer", fontSize: '12px' }}
                              onClick={() => {
                                setEditTarget(reply.review_c_seq);
                                setEditText(reply.contents); // 기존 댓글 내용 입력창에 세팅
                              }}
                            > 
                              {" "}/{" "}수정
                            </span>
                            <span
                              style={{ cursor: "pointer", fontSize: '12px' }}
                              onClick={() => {
                                onDeleteComment('comment', reply.review_c_seq);
                              }}
                            > 
                              {" "}/{" "}삭제 
                            </span>
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                </div>
              ))}

            {/* <div style={{ display: "flex", gap: "1px", marginTop: "20px" }}>
              <AutoResizeTextarea
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
                placeholder= {isNocomment ? "댓글을 제한하였습니다" : "댓글을 입력하세요"}
                readOnly={isNocomment}
              />
              <button
                onClick={() => {
                  onSubmitComment(detailData?.review_seq, commentText);
                  setCommentText("");
                }}
                style={{
                  alignSelf: "stretch", // 버튼이 textarea 높이에 맞춰짐
                  padding: "8px 12px",
                  fontSize: "14px",
                  backgroundColor: isNocomment ? "#ccc" : "#81b8f8",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: isNocomment ? "not-allowed" : "pointer",
                  width:'30%',
                }}
                disabled={isNocomment}
              >
                등록하기
              </button>
            </div> */}
            <div className="main-btn d-flex justify-content-center">
              <button onClick={() => navigate("/announcement", { state: 3 })}>목록</button>
            </div>
          </div>
        </div>
      </div>
      <ModalConfirm 
        show={showModalConfirm} 
        onHide={() => setShowModalConfirm(false)}
        onComfirm={() => onDeleteComment('review', detailData.review_seq)}
        onCancel={() => setShowModalConfirm(false)}
        title=""
        text="이용 후기를 정말로 삭제하시겠습니까?"
      />
      <FilePreviewModal
        show={showModal}
        onHide={() => setShowModal(false)}
        previewUrl={previewUrl}
        contentType={contentType}
      />
      <MobileFooter main={true} />
    </>
  );
}
